module.exports = __webpack_public_path__ + "img/sales_inventory_matching.f9c9a6f9.svg";